import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function templateVariableValidator(allowedVariables: string[]): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (typeof control.value !== 'string') return null;

		const text = control.value;

		const validVariableRegex = /{{\s[^{}\s][^{}]*\s}}/g;
		const validMatches = (text.match(validVariableRegex) || []) as string[];

		const loosePatternRegex = /{{[^{}]+}}|{[^{}]+}|{{[^{}]+}|[^{}]+}}/g;
		const looseMatches = (text.match(loosePatternRegex) || []) as string[];

		const excessiveBracesRegex = /({{{+[^{}]*}}+|{{+[^{}]*}}}+)/g;
		const excessiveMatches = (text.match(excessiveBracesRegex) || []) as string[];

		const allInvalidFormatCandidates = [...new Set([...looseMatches, ...excessiveMatches])];
		const invalidFormatMatches = allInvalidFormatCandidates.filter((m) => !validMatches.includes(m));

		const invalidValueMatches = validMatches.filter((v) => !allowedVariables.includes(v));

		const errors: ValidationErrors = {};
		if (invalidFormatMatches.length > 0) {
			errors.invalidFormat = { invalid: invalidFormatMatches };
		}
		if (invalidValueMatches.length > 0) {
			errors.invalidTemplateVariables = { invalid: invalidValueMatches };
		}

		return Object.keys(errors).length > 0 ? errors : null;
	};
}
